import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'recommend-event-modal',
  templateUrl: 'recommend-event.component.html',
  styleUrls: ['recommend-event.component.scss'],
  standalone: false
})

export class RecommendedEventModal {
  recommendationText = signal('');
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<RecommendedEventModal>) {
  }

  createRecommendation(){
    this.dialogRef.close(this.recommendationText());
  }
}
